import React from "react";
import { categories } from "../../data/product";
export function CategoryGrid() {
  return <ul className="grid grid-flow-col grid-cols-2 grid-rows-5 gap-x-3 gap-y-3 sm:gap-x-6" data-id="element-169" data-mp="sfqjc18mznrk">
      {categories.map(({
      count,
      label,
      icon: Icon
    }) => <li key={label} className="flex items-start gap-2 text-[14px] leading-snug text-ink sm:text-[15px]" data-id="element-170" data-mp="dq18feaqs5e3">
          <Icon className="mt-0.5 h-[18px] w-[18px] shrink-0 text-rose" strokeWidth={1.5} aria-hidden="true" data-id="element-171" data-mp="inb61h8abnd0" />
          <span data-id="element-172" data-mp="9opo9oan0cda">
            <strong className="mr-1 font-bold text-wine" data-id="element-173" data-mp="9p8va9yr1gcj">{count}</strong>
            {label}
          </span>
        </li>)}
    </ul>;
}